<template>
  <q-btn
          icon="fa fa-plus"
          :label="label"
          v-bind="$attrs"
          @click="openModal"/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client, Report } from '@/type';
import openModal from '@/components/modal';
import GenerateReportModal from './GenerateReportModal.vue';

export default defineComponent({
  emits: ['generated'],
  props: {
    client: {
      type: Object as () => Client,
      required: true,
    },
    label: {
      type: String,
      default: 'Generate Report',
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        client: this.client,
      };
      openModal(GenerateReportModal, config)
        .onOk((report: Report) => {
          this.$emit('generated', report);
        });
    },
  },
});
</script>
